export default __webpack_public_path__ + "static/media/logo-black.485727d7.svg";